// @flow
import React from 'react'
import _omit from 'lodash/omit'

type PropsT = Object

const Checkbox = (props: PropsT) => (
  <input
    {..._omit(props, 'indeterminate')}
    type='checkbox'
    ref={input => {
      if (input) {
        input.indeterminate = props.checked ? false : props.indeterminate
      }
    }}
  />
)

export default Checkbox
